export default "https://cdn-static.gokick.com/assets/b11b69440b74c450e5ca5f7ba176f3cdc3a0fffe/images/two-pack.1e6632cffb735562eaf44e7ebc36435e.png";